import { render, staticRenderFns } from "./ebs-reports-icon.vue?vue&type=template&id=7f18408f"
import script from "./ebs-reports-icon.vue?vue&type=script&lang=js"
export * from "./ebs-reports-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports